export default "__VITE_ASSET__DTtbucoD__"